export const messageBoardConstants = {
	MessageBoard_GetByFilter_Request : "MESSAGE_BOARD_GET_ALL_STARTED",
	MessageBoard_GetByFilter_Success : "MESSAGE_BOARD_GET_ALL_COMPLETED",
	MessageBoard_GetByFilter_Failure: "MESSAGE_BOARD_GET_ALL_FAILED",

	MessageBoard_Save_Request: "MESSAGE_BOARD_SAVE_STARTED",
	MessageBoard_Save_Success: "MESSAGE_BOARD_SAVE_COMPLETED",
	MessageBoard_Save_Failure: "MESSAGE_BOARD_SAVE_FAILED",

	MessageBoard_GetDetail_Request : "MESSAGE_BOARD_GET_DETAIL_STARTED",
	MessageBoard_GetDetail_Success : "MESSAGE_BOARD_GET_DETAIL_COMPLETED",
	MessageBoard_GetDetail_Failure : "MESSAGE_BOARD_GET_DETAIL_FAILED",

	MessageBoard_Delete_Request: "MESSAGED_BOARD_DELETE_STARTED",
	MessageBoard_Delete_Success: "MESSAGED_BOARD_DELETE_COMPLETED",
	MessageBoard_Delete_Failure: "MESSAGED_BOARD_DELETE_FAILED",

	MessageBoard_GetReport_Request : "MESSAGE_BOARD_GET_REPORT_STARTED",
	MessageBoard_GetReport_Success : "MESSAGE_BOARD_GET_REPORT_COMPLETED",
	MessageBoard_GetReport_Failure : "MESSAGE_BOARD_GET_REPORT_FAILED",

	MessageBoard_GetTopic_Request : "MESSAGE_BOARD_GET_TOPIC_STARTED",
	MessageBoard_GetTopic_Success : "MESSAGE_BOARD_GET_TOPIC_COMPLTED",
	MessageBoard_GetTopic_Failure : "MESSAGE_BOARD_GET_TOPIC_FAILED",

	MessageBoard_TopicDelete_Request : "MESSAGE_BOARD_DELETE_TOPIC_STARTED",
	MessageBoard_TopicDelete_Success : "MESSAGE_BOARD_DELETE_TOPIC_COMPLETED",
	MessageBoard_TopicDelete_Failure: "MESSAGE_BOARD_DELETE_TOPIC_FAILED",

	MessageBoard_TopicRestore_Request: "MESSAGE_BOARD_RESTORE_TOPIC_STARTED",
	MessageBoard_TopicRestore_Success: "MESSAGE_BOARD_RESTORE_TOPIC_COMPLETED",
	MessageBoard_TopicRestore_Failure: "MESSAGE_BOARD_RESTORE_TOPIC_FAILED",

	MessageBoard_GetPostByFilter_Request : "MESSAGE_BOARD_GET_POST_STARTED",
	MessageBoard_GetPostByFilter_Success : "MESSAGE_BOARD_GET_POST_COMPLETED",
	MessageBoard_GetPostByFilter_Failure : "MESSAGE_BOARD_GET_POST_FAILED",

	MessageBoard_GetAlert_Request : "MESSAGE_BOARD_GET_ALERT_STARED",
	MessageBoard_GetAlert_Success : "MESSAGE_BOARD_GET_ALERT_COMPLETED",
	MessageBoard_GetAlert_Failure : "MESSAGE_BOARD_GET_ALERT_FAILED",

	MessageBoard_PostDelete_Request : "MESSAGE_BOARD_DELETE_POST_STARTED",
	MessageBoard_PostDelete_Success : "MESSAGE_BOARD_DELETE_POST_COMPLETED",
	MessageBoard_PostDelete_Failure: "MESSAGE_BOARD_DELETE_POST_FAILED",

	MessageBoard_PostRestore_Request: "MESSAGE_BOARD_RESTORE_POST_STARTED",
	MessageBoard_PostRestore_Success: "MESSAGE_BOARD_RESTORE_POST_COMPLETED",
	MessageBoard_PostRestore_Failure: "MESSAGE_BOARD_RESTORE_POST_FAILED",

	MessageBoard_PostFlag_Request : "MESSAGE_BOARD_FLAG_POST_STARTED",
	MessageBoard_PostFlag_Success : "MESSAGE_BOARD_FLAG_POST_COMPLETED",
	MessageBoard_PostFlag_Failure : "MESSAGE_BOARD_FLAG_POST_FAILED",

	MessageBoard_PostAuthorization_Request : "MESSAGE_BOARD_POST_APPROVE_REJECT_STARTED",
	MessageBoard_PostAuthorization_Success : "MESSAGE_BOARD_POST_APPROVE_REJECT_COMPLETED",
	MessageBoard_PostAuthorization_Failure : "MESSAGE_BOARD_POST_APPROVE_REJECT_FAILED",

	MessageBoard_GetReportType_Request : "MESSAGE_BOARD_GET_REPORT_TYPE_STARTED",
	MessageBoard_GetReportType_Success : "MESSAGE_BOARD_GET_REPORT_TYPE_COMPLETED",
	MessageBoard_GetReportType_Failure : "MESSAGE_BOARD_GET_REPORT_TYPE_FAILED",

	MessageBoard_GetCountByYear_Request : "MESSAGE_BOARD_GET_COUNTBYYEAR_STARTED",
	MessageBoard_GetCountByYear_Success : "MESSAGE_BOARD_GET_COUNTBYYEAR_COMPLETED",
	MessageBoard_GetCountByYear_Failure : "MESSAGE_BOARD_GET_COUNTBYYEAR_FAILED",

	MessageBoard_GetUserPublicMessage_Request : "MESSAGE_BOARD_GET_USER_PUBLIC_MSG_STARTED",
	MessageBoard_GetUserPublicMessage_Success : "MESSAGE_BOARD_GET_USER_PUBLIC_MSG_COMPLETED",
	MessageBoard_GetUserPublicMessage_Failure : "MESSAGE_BOARD_GET_USER_PUBLIC_MSG_FAILED",

	MessageBoard_GetUserChannelMessage_Request : "MESSAGE_BOARD_GET_USER_CHANNEL_MSG_STARTED",
	MessageBoard_GetUserChannelMessage_Success : "MESSAGE_BOARD_GET_USER_CHANNEL_MSG_COMPLETED",
	MessageBoard_GetUserChannelMessage_Failure: "MESSAGE_BOARD_GET_USER_CHANNEL_MSG_FAILED",
}